module.exports = __webpack_public_path__ + "images/55c8b84c4ff073709d18a05a9bbe2b1eaudio.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audio.png
// module id = u6Hf
// module chunks = 0